import ProductApi from "@/services/api/productApi";

const ProductApiService = new ProductApi();

export default {
  inject: ["$validator"],

  data() {
    return {
      url: "",
      error: "",
    };
  },

  methods: {
    validate,
    close,
  },

  mounted() {
    this.$refs.urlInput.focus();
  },
};

function validate() {
  const _self = this;

  try {
    const url = new URL(this.url),
      matchedURL = this.$router.match(url.pathname);

    if (matchedURL.name !== "notFound" && matchedURL.params.productId) {
      ProductApiService.getProduct(matchedURL.params.productId)
        .then(({ data }) => {
          _self.$emit("submit", {
            ...data,
            brand: {
              company_name: data.brand_name,
              id: data.brand_id,
              minimum_order_value: data.brand_minimum_order_value,
              vanity_url_name: data.brand_vanity_url_name,
            },
          });
          _self.$emit("close");
        })
        .catch((error) => {
          if (error.response) {
            _self.$swal("Attention", "There was no product found at the entered URL, or the product was deleted.");
          } else {
            _self.$bugsnagClient.notify(new Error(error));
          }
        });
      this.error = null;
    } else {
      throw false;
    }
  } catch (error) {
    this.error = "This is not a valid url. Please try another one.";
  }
}

function close() {
  this.$emit("close");
}
